import Noty from 'noty'

const NotyPlugin = {
  install (Vue, { text }) {
    const ntype = {
      ADDED: {
        type: 'success',
        text: text.ADDED,
        timeout: 1000
      },
      UPDATED: {
        type: 'success',
        text: text.UPDATED,
        timeout: 1000
      },
      IMPORTED: {
        type: 'success',
        text: text.IMPORTED,
        timeout: 1000
      },
      SENT: {
        type: 'success',
        text: text.SENT,
        timeout: 1000
      },
      URL_COPIED: {
        type: 'success',
        text: text.URL_COPIED,
        timeout: 1000
      },
      ONLINE_RECOVERY: {
        type: 'success',
        text: text.ONLINE_RECOVERY,
        timeout: 1000 * 2
      },
      OFFLINE: {
        type: 'error',
        text: text.OFFLINE,
        timeout: false,
        closeWith: [],
        buttons: [
          Noty.button(text.RETRY, 'ui button tiny inverted btn', () => {
            location.reload()
          })
        ]
      },
      ERROR_PERMISSION: {
        type: 'error',
        text: text.ERROR_PERMISSION,
        timeout: 1000 * 2
      },
      ERROR_ITEMS_EXCEEDED: {
        type: 'error',
        text: text.ERROR_ITEMS_EXCEEDED,
        timeout: 1000 * 2
      },
      ERROR_INVALID_AUTH: {
        type: 'error',
        text: text.ERROR_INVALID_AUTH,
        timeout: 1000 * 2
      },
      ERROR_INVALID_PROVIDER: {
        type: 'error',
        text: text.ERROR_INVALID_PROVIDER,
        timeout: 1000 * 2
      },
      ERROR_PAYMENT_DECLINED: {
        type: 'error',
        text: text.ERROR_PAYMENT_DECLINED,
        timeout: 1000 * 2
      },
      ERROR_UNKNOWN: {
        type: 'error',
        text: text.ERROR_UNKNOWN,
        timeout: 1000 * 2
      },
      ERROR_NOT_FOUND: {
        type: 'error',
        text: text.ERROR_NOT_FOUND,
        timeout: 1000 * 2
      },
      ERROR_NO_QUOTA: {
        type: 'error',
        text: text.ERROR_NO_QUOTA,
        timeout: 1000 * 2
      },
      ERROR_ADMIN_CONTACT: {
        type: 'error',
        text: text.ERROR_ADMIN_CONTACT,
        timeout: 1000 * 2
      }
    }

    Vue.prototype.$ntype = {
      ADDED: 'ADDED',
      UPDATED: 'UPDATED',
      IMPORTED: 'IMPORTED',
      SENT: 'SENT',
      ONLINE_RECOVERY: 'ONLINE_RECOVERY',
      OFFLINE: 'OFFLINE',
      URL_COPIED: 'URL_COPIED'
    }

    Vue.prototype.$noty = createNoty
    Vue.prototype.$notyError = function (e) {
      const code = e.response ? e.response.body.code : e.code

      switch (code) {
        case 'PERMISSION_DENIED':
          createNoty('ERROR_PERMISSION')
          break
        case 'NOT_FOUND':
          createNoty('ERROR_NOT_FOUND')
          break
        case 'PAYMENT_DECLINED':
          createNoty('ERROR_PAYMENT_DECLINED')
          break
        case 'ITEMS_EXCEEDED':
          createNoty('ERROR_ITEMS_EXCEEDED')
          break
        case 'INVALID_AUTH':
          createNoty('ERROR_INVALID_AUTH')
          break
        case 'INVALID_PROVIDER':
          createNoty('ERROR_INVALID_PROVIDER')
          break
        case 'NO_QUOTA':
          createNoty('ERROR_NO_QUOTA')
          break
        case 'INVALID_QUOTA':
          createNoty('ERROR_ADMIN_CONTACT')
          break
        default:
          createNoty('ERROR_UNKNOWN')
          throw e
      }
    }

    function createNoty (type) {
      return new Noty(Object.assign({
        layout: 'bottomRight',
        progressBar: false,
        animation: {
          open: 'noty-open',
          close: 'noty-close'
        }
      }, ntype[type])).show()
    }
  }
}

export default NotyPlugin
